import React, { useEffect, useState } from 'react';
import { getdata } from '../../util/global';

export default function DummyGateway() {
  const [orderid, setorderid] = useState('');
  const [subscriptionid, setsubscriptionid] = useState('');
  const [amount, setamount] = useState('0');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setorderid(params.get('order_id') || '');
    setsubscriptionid(params.get('subscriptionid') || '');
    setamount(params.get('amount') || '0');
  }, []);

  async function handlesuccess() {
    const paymentid = 'pay_mock_' + Math.random().toString(36).slice(2, 10);
    const signature = 'sig_mock_' + Math.random().toString(36).slice(2, 14);

    // posts like razorpay's callback_url does; the server redirects the browser to /verifymandatefrontend
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = '/verifymandate';
    const fields = {
      razorpay_order_id: orderid,
      razorpay_payment_id: paymentid,
      razorpay_signature: signature,
      subscriptionid: subscriptionid
    };
    for (const [name, value] of Object.entries(fields)) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    }
    document.body.appendChild(form);
    form.submit();
  }

  function handlecancel() {
    window.location.href = '/subscriptions';
  }

  return (
    <div className="container mt-5" style={{ maxWidth: '440px' }}>
      <div className="card shadow-sm p-4">
        <div className="text-center mb-3">
          <span className="badge bg-info text-dark mb-2">TEST GATEWAY</span>
          <h5>Razorpay UPI Autopay</h5>
          <p className="text-muted small mb-0">Simulate mandate authorization</p>
        </div>

        <ul className="list-group list-group-flush mb-3">
          <li className="list-group-item d-flex justify-content-between px-0">
            <span className="text-muted">Order ID:</span>
            <code>{orderid || '-'}</code>
          </li>
          <li className="list-group-item d-flex justify-content-between px-0">
            <span className="text-muted">Subscription ID:</span>
            <code>{subscriptionid || '-'}</code>
          </li>
          <li className="list-group-item d-flex justify-content-between px-0 fw-bold">
            <span>First Charge:</span>
            <span className="text-success">₹{amount}</span>
          </li>
        </ul>

        <div className="d-grid gap-2">
          <button className="btn btn-primary" onClick={handlesuccess}>
            Authorize & Approve Mandate
          </button>
          <button className="btn btn-outline-secondary" onClick={handlecancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}